const appendRouter = {
  // 短信
  "/acquisition": [
    {
      path: "/sms",
      component: () => import("@/views/acquisition/sms.vue"),
      name: "acquisitionSms",
      meta: { title: "短信配置" },
    },
  ],
  // 课程
  "/course": [
    // 素材中心
    {
      path: "/source",
      component: () => import("@/views/sources/index"),
      name: "sourceIndex",
      meta: { title: "素材管理" },
    },
    {
      path: "/traffic",
      component: () => import("@/views/sources/traffic"),
      name: "traffic",
      meta: { title: "流量中心" },
    },
    {
      path: "/package",
      component: () => import("@/views/sources/package"),
      name: "package",
      meta: { title: "版本中心" },
    },
    {
      path: "/live/create",
      component: () => import("@/views/live/edit"),
      name: "sourceIndex",
      meta: { title: "新建直播" },
    },
    {
      path: "/live/edit",
      component: () => import("@/views/live/edit"),
      name: "sourceIndex",
      meta: { title: "编辑直播" },
    },
    {
      path: "/live/batch",
      component: () => import("@/views/live/batch"),
      name: "sourceIndex",
      meta: { title: "批量创建直播" },
    },
    {
      path: "/live/list",
      component: () => import("@/views/live/list"),
      name: "sourceIndex",
      meta: { title: "直播管理" },
    },
    {
      path: "/live/soft",
      component: () => import("@/views/live/soft"),
      name: "sourceIndex",
      meta: { title: "软件下载" },
    },
    {
      path: "/course/column",
      component: () => import("@/views/course/column"),
      name: "column",
      meta: { title: "专栏管理" },
    },
    {
      path: "/course/private",
      component: () => import("@/views/course/video"),
      name: "private",
      meta: { title: "私教管理" },
    },
    {
      path: "/course/service",
      component: () => import("@/views/course/video"),
      name: "service",
      meta: { title: "服务管理" },
    },
    {
      path: "/platform/list",
      component: () => import("@/views/course/platformList"),
      name: "platformGuide",
      meta: { title: "多平台上架" },
    },
    {
      path: "/platform/dy",
      component: () => import("@/views/platform/dy"),
      name: "guide",
      meta: { title: "抖音" },
    },
    {
      path: "/platform/dy/edit",
      component: () => import("@/views/platform/dyEdit"),
      name: "guide",
      meta: { title: "抖音" },
    },
    {
      path: "/platform/ks",
      component: () => import("@/views/platform/ks"),
      name: "guide",
      meta: { title: "快手" },
    },
    {
      path: "/platform/ks/edit",
      component: () => import("@/views/platform/ksEdit"),
      name: "guide",
      meta: { title: "快手" },
    },
    {
      path: "/platform/sph",
      component: () => import("@/views/platform/sph"),
      name: "guide",
      meta: { title: "视频号" },
    },
    {
      path: "/platform/sph/edit",
      component: () => import("@/views/platform/sphEdit"),
      name: "guide",
      meta: { title: "视频号" },
    },
    {
      path: "/platform/xhs",
      component: () => import("@/views/platform/xhs"),
      name: "guide",
      meta: { title: "小红书" },
    },
    {
      path: "/platform/xhs/edit",
      component: () => import("@/views/platform/xhsEdit"),
      name: "guide",
      meta: { title: "小红书" },
    },
    {
      path: "/platform/code",
      component: () => import("@/views/marketing/code"),
      name: "marketingCode",
      meta: { title: "兑换码" },
    },
    {
      path: "/interaction/documents",
      component: () => import("@/views/interaction/documents"),
      name: "teacher",
      meta: { title: "资料管理", noCache: true },
    },
    {
      path: "/interaction/punch",
      component: () => import("@/views/interaction/punch"),
      name: "teacher",
      meta: { title: "打卡", noCache: true },
    },
    {
      path: "/interaction/punch/edit",
      component: () => import("@/views/interaction/punchEdit"),
      name: "teacher",
      meta: { title: "打卡", noCache: true },
    },
    {
      path: "/interaction/punch/detail",
      component: () => import("@/views/interaction/punchDetail"),
      name: "teacher",
      meta: { title: "打卡", noCache: true },
    },
    {
      path: "/interaction/exam",
      component: () => import("@/views/interaction/exam"),
      name: "book",
      meta: { title: "考试", noCache: true },
    },
    {
      path: "/interaction/practice",
      component: () => import("@/views/interaction/practice"),
      name: "courseware",
      meta: { title: "练习", noCache: true },
    },
    {
      path: "/interaction/homework",
      component: () => import("@/views/interaction/homework"),
      name: "teacher",
      meta: { title: "作业本", noCache: true },
    },
    {
      path: "/interaction/question",
      component: () => import("@/views/interaction/question"),
      name: "book",
      meta: { title: "题库", noCache: true },
    },
    {
      path: "/interaction/cert",
      component: () => import("@/views/interaction/cert"),
      name: "courseware",
      meta: { title: "证书", noCache: true },
    },
    {
      path: "/interaction/cert/edit",
      component: () => import("@/views/interaction/certEdit"),
      name: "courseware",
      meta: { title: "证书", noCache: true },
    },
    {
      path: "/interaction/form",
      component: () => import("@/views/interaction/form"),
      name: "courseware",
      meta: { title: "表单", noCache: true },
    },
    {
      path: "/interaction/activity",
      component: () => import("@/views/interaction/activity"),
      name: "courseware",
      meta: { title: "活动管理", noCache: true },
    },
    {
      path: "/interaction/detection",
      component: () => import("@/views/interaction/detection"),
      name: "teacher",
      meta: { title: "随堂检测", noCache: true },
    },
    {
      path: "/interaction/test",
      component: () => import("@/views/interaction/test"),
      name: "book",
      meta: { title: "测试互动", noCache: true },
    },
    {
      path: "/interaction/qapayment",
      component: () => import("@/views/interaction/qapayment"),
      name: "courseware",
      meta: { title: "付费问答", noCache: true },
    },
    {
      path: "/interaction/comment",
      component: () => import("@/views/interaction/comment"),
      name: "courseware",
      meta: { title: "评论管理", noCache: true },
    },
    {
      path: "/p/course/guide",
      component: () => import("@/views/course/guide"),
      name: "guide",
      meta: { title: "课程管理" },
    },
    {
      path: "/course/video/create",
      component: () => import("@/views/course/createCourse"),
      name: "createCourse",
      meta: { title: "新建课程", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/video/create",
      component: () => import("@/views/course/createCourse"),
      name: "createCourse",
      meta: { title: "新建课程", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/column/create",
      component: () => import("@/views/course/createColumn"),
      name: "createColumn",
      meta: { title: "新建专栏", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/column/copy",
      component: () => import("@/views/course/createColumn"),
      name: "createCourse",
      meta: { title: "复制专栏", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/audio/create",
      component: () => import("@/views/course/createCourse"),
      name: "createAudio",
      meta: { title: "新建音频", prefix: "/course/audio" },
      hidden: true,
    },
    {
      path: "/course/richtext/create",
      component: () => import("@/views/course/createCourse"),
      name: "createRichtext",
      meta: { title: "新建图文", prefix: "/course/richtext" },
      hidden: true,
    },
    {
      path: "/course/mixture/create",
      component: () => import("@/views/course/createCourse"),
      name: "createMixture",
      meta: { title: "新建组合课", prefix: "/course/mixture" },
      hidden: true,
    },
    {
      path: "/course/video/manage",
      component: () => import("@/views/course/courseManage"),
      name: "videoManage",
      meta: { title: "课程管理", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/column/manage",
      component: () => import("@/views/course/courseManage"),
      name: "videoManage",
      meta: { title: "课程管理", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/audio/manage",
      component: () => import("@/views/course/courseManage"),
      name: "audioManage",
      meta: { title: "课程管理", prefix: "/course/audio" },
      hidden: true,
    },
    {
      path: "/course/richtext/manage",
      component: () => import("@/views/course/courseManage"),
      name: "richtextManage",
      meta: { title: "课程管理", prefix: "/course/richtext" },
      hidden: true,
    },
    {
      path: "/course/mixture/manage",
      component: () => import("@/views/course/courseManage"),
      name: "mixtureManage",
      meta: { title: "课程管理", prefix: "/course/mixture" },
      hidden: true,
    },
    {
      path: "/course/video/poster",
      component: () => import("@/views/course/poster"),
      name: "videoPoster",
      meta: { title: "课程海报", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/video/playbill",
      component: () => import("@/views/course/playbill"),
      name: "videoPlaybill",
      meta: { title: "课程海报", prefix: "/course/video" },
      hidden: true,
    },
    {
      path: "/course/activity/sort",
      component: () => import("@/views/course/activity"),
      name: "activitySort",
      meta: { title: "课程排序", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/course/lesson",
      component: () => import("@/views/course/lesson"),
      name: "lesson",
      meta: { title: "课程", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/video/edit",
      component: () => import("@/views/course/activityVideoEdit"),
      name: "lesson",
      meta: { title: "视频管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/course/activityList",
      component: () => import("@/views/course/activityList"),
      name: "lessonList",
      meta: { title: "单课管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/video",
      component: () => import("@/views/course/activityVideo"),
      name: "lesson",
      meta: { title: "视频管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/video/batch",
      component: () => import("@/views/course/activityVideoBatch"),
      name: "lesson",
      meta: { title: "视频管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/audio",
      component: () => import("@/views/course/activityAudio"),
      name: "lesson",
      meta: { title: "音频管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/audio/edit",
      component: () => import("@/views/course/activityAudioEdit"),
      name: "lesson",
      meta: { title: "音频管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/audio/batch",
      component: () => import("@/views/course/activityAudioBatch"),
      name: "lesson",
      meta: { title: "音频管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/rich",
      component: () => import("@/views/course/activityRich"),
      name: "lesson",
      meta: { title: "图文管理", prefix: "/course" },
      hidden: true,
    },
    {
      path: "/content/rich/edit",
      component: () => import("@/views/course/activityRichEdit"),
      name: "lesson",
      meta: { title: "图文管理", prefix: "/course" },
      hidden: true,
    },
  ],

  // 全域获客
  "/platform": [],

  // 教学管理
  "/teach": [],

  // 用户管理
  "/user": [
    {
      path: "/user/detail",
      component: () => import("@/views/user/userDetail"),
      name: "userDetail",
      meta: { title: "用户详情", prefix: "/user/index" },
      hidden: true,
    },
    {
      path: "/user/tags",
      component: () => import("@/views/user/tags"),
      name: "userDetail",
      meta: { title: "标签管理", prefix: "/user" },
      hidden: true,
    },
    {
      path: "/user/tags/edit",
      component: () => import("@/views/user/tagEdit"),
      name: "userDetail",
      meta: { title: "标签管理", prefix: "/user" },
      hidden: true,
    },
    {
      path: "/groups/autoreply",
      component: () => import("@/views/user/groupAutoReply"),
      name: "groupAutoReply",
      meta: { title: "自动回复", prefix: "/user/groups" },
      hidden: true,
    },
  ],

  // 数据中心
  "/database": [
    {
      path: "/database/analysis",
      component: () => import("@/views/database/analysis"),
      name: "databaseAnalysis",
      meta: { title: "数据分析", prefix: "/database/analysis" },
      hidden: true,
    },
  ],

  // 互动管理
  "/interaction": [
    {
      path: "/interaction/pages",
      component: () => import("@/views/interaction/pages"),
      name: "interactionPages",
      meta: { title: "数据分析", prefix: "/interaction" },
      hidden: true,
    },
  ],

  // 营销工具
  "/marketing": [
    {
      path: "/marketing/coupon/add",
      component: () => import("@/views/marketing/addCoupon"),
      name: "addCoupon",
      meta: { title: "添加优惠券", prefix: "/marketing/coupon" },
      hidden: true,
    },
    {
      path: "/marketing/coupon/edit",
      component: () => import("@/views/marketing/couponEdit"),
      name: "addCoupon",
      meta: { title: "添加优惠券", prefix: "/marketing/coupon" },
      hidden: true,
    },
    {
      path: "/marketing/coupon/code",
      component: () => import("@/views/marketing/couponCode"),
      name: "couponCode",
      meta: { title: "领取优惠券列表", prefix: "/marketing/coupon" },
      hidden: true,
    },
    {
      path: "/marketing/limited/create",
      component: () => import("@/views/marketing/limitedEdit"),
      name: "addLimited",
      meta: { title: "新建限时抢购", prefix: "/marketing/limited" },
      hidden: true,
    },
    {
      path: "/marketing/limited/edit",
      component: () => import("@/views/marketing/limitedEdit"),
      name: "editLimited",
      meta: { title: "编辑限时抢购", prefix: "/marketing/limited" },
      hidden: true,
    },
    {
      path: "/marketing/group",
      component: () => import("@/views/marketing/group"),
      name: "group",
      meta: { title: "拼团" },
    },
    {
      path: "/marketing/group/create",
      component: () => import("@/views/marketing/groupEdit"),
      name: "addGroup",
      meta: { title: "创建拼团" },
    },
    {
      path: "/marketing/group/edit",
      component: () => import("@/views/marketing/groupEdit"),
      name: "editGroup",
      meta: { title: "编辑拼团" },
    },
    {
      path: "/marketing/course",
      component: () => import("@/views/marketing/course"),
      name: "marketingCourse",
      meta: { title: "买课送课" },
    },
    {
      path: "/marketing/course/create",
      component: () => import("@/views/marketing/courseEdit"),
      name: "addCourse",
      meta: { title: "创建买课送课" },
    },
    {
      path: "/marketing/course/edit",
      component: () => import("@/views/marketing/courseEdit"),
      name: "editCourse",
      meta: { title: "编辑买课送课" },
    },
    {
      path: "/marketing/packet",
      component: () => import("@/views/marketing/packet"),
      name: "packet",
      meta: { title: "套餐" },
    },
    {
      path: "/marketing/packet/create",
      component: () => import("@/views/marketing/packetEdit"),
      name: "addPacket",
      meta: { title: "创建套餐" },
    },
    {
      path: "/marketing/packet/edit",
      component: () => import("@/views/marketing/packetEdit"),
      name: "editPacket",
      meta: { title: "编辑套餐" },
    },
    // {
    //   path: "/marketing/page",
    //   component: () => import("@/views/marketing/page"),
    //   name: "editPacket",
    //   meta: { title: "店铺装修" },
    // },
    {
      path: "/marketing/page",
      component: () => import("@/views/marketing/page"),
      name: "editPage",
      meta: { title: "店铺装修" },
    },
    {
      path: "/planet/editPlanet",
      component: () => import("@/views/planet/editPlanet"),
      name: "editPlanet",
      meta: { title: "星球编辑", prefix: "/editPlanet" },
    },
    {
      path: "/p/planet/editPlanet",
      component: () => import("@/views/planet/editPlanet"),
      name: "editPlanet",
      meta: { title: "星球编辑", prefix: "/editPlanet" },
    },
    {
      path: "/planet/detail",
      name: "planetDetail",
      component: (resolve) => require(["@/views/planet/detail"], resolve),
      children: [
        {
          path: "/planet/configs",
          name: "planetConfigs",
          component: (resolve) =>
            require(["@/views/planet/views/configs"], resolve),
        },
        {
          path: "/planet/active",
          name: "planetActive",
          component: (resolve) =>
            require(["@/views/planet/views/active"], resolve),
        },
        {
          path: "/planet/columns",
          name: "planetColumns",
          component: (resolve) =>
            require(["@/views/planet/views/columns"], resolve),
        },
        {
          path: "/planet/cards",
          name: "planetCards",
          component: (resolve) =>
            require(["@/views/planet/views/cards"], resolve),
        },
        {
          path: "/planet/cards/punchcardList",
          name: "planetPunchcardList",
          component: (resolve) =>
            require(["@/views/planet/views/punchcardList"], resolve),
        },
        {
          path: "/planet/homework",
          name: "planetHomework",
          component: (resolve) =>
            require(["@/views/planet/views/homework"], resolve),
        },
        {
          path: "/planet/homework/homeworkList",
          name: "planetHomeworkList",
          component: (resolve) =>
            require(["@/views/planet/views/homeworkList"], resolve),
        },
        {
          path: "/planet/ask",
          name: "planetAsk",
          component: (resolve) =>
            require(["@/views/planet/views/ask"], resolve),
        },
        {
          path: "/planet/member",
          name: "planetMember",
          component: (resolve) =>
            require(["@/views/planet/views/member"], resolve),
        },
        {
          path: "/planet/data",
          name: "planetData",
          component: (resolve) =>
            require(["@/views/planet/views/data"], resolve),
        },
        {
          path: "/planet/tags",
          name: "admPlanetTags",
          component: (resolve) =>
            require(["@/views/planet/views/tags"], resolve),
        },
        {
          path: "/planet/menus",
          name: "admPlanetMenus",
          component: (resolve) =>
            require(["@/views/planet/views/menus"], resolve),
        },
        {
          path: "/planet/setting",
          name: "planetSetting",
          component: (resolve) =>
            require(["@/views/planet/views/setting"], resolve),
        },
      ],
    },
    {
      path: "/p/planet/detail",
      name: "planetDetail",
      component: (resolve) => require(["@/views/planet/detail"], resolve),
      children: [
        {
          path: "/p/planet/configs",
          name: "planetConfigs",
          component: (resolve) =>
            require(["@/views/planet/views/configs"], resolve),
        },
        {
          path: "/p/planet/wechatGroup",
          name: "wechatGroup",
          component: (resolve) =>
            require(["@/views/planet/views/wechatGroup.vue"], resolve),
        },
        {
          path: "/p/planet/liveList",
          name: "liveList",
          component: (resolve) =>
            require(["@/views/planet/views/liveList.vue"], resolve),
        },
        {
          path: "/p/planet/planetBook",
          name: "planetBook",
          component: (resolve) =>
            require(["@/views/planet/views/book.vue"], resolve),
        },
        {
          path: "/p/planet/active",
          name: "planetActive",
          component: (resolve) =>
            require(["@/views/planet/views/active"], resolve),
        },
        {
          path: "/p/planet/columns",
          name: "planetColumns",
          component: (resolve) =>
            require(["@/views/planet/views/columns"], resolve),
        },
        {
          path: "/p/planet/cards",
          name: "planetCards",
          component: (resolve) =>
            require(["@/views/planet/views/cards"], resolve),
        },
        {
          path: "/p/planet/cards/punchcardList",
          name: "planetPunchcardList",
          component: (resolve) =>
            require(["@/views/planet/views/punchcardList"], resolve),
        },
        {
          path: "/p/planet/homework",
          name: "planetHomework",
          component: (resolve) =>
            require(["@/views/planet/views/homework"], resolve),
        },
        {
          path: "/p/planet/homework/homeworkList",
          name: "planetHomeworkList",
          component: (resolve) =>
            require(["@/views/planet/views/homeworkList"], resolve),
        },
        {
          path: "/p/planet/ask",
          name: "planetAsk",
          component: (resolve) =>
            require(["@/views/planet/views/ask"], resolve),
        },
        {
          path: "/p/planet/member",
          name: "planetMember",
          component: (resolve) =>
            require(["@/views/planet/views/member"], resolve),
        },
        {
          path: "/p/planet/data",
          name: "planetData",
          component: (resolve) =>
            require(["@/views/planet/views/data"], resolve),
        },
        {
          path: "/p/planet/tags",
          name: "admPlanetTags",
          component: (resolve) =>
            require(["@/views/planet/views/tags"], resolve),
        },
        {
          path: "/p/planet/menus",
          name: "admPlanetMenus",
          component: (resolve) =>
            require(["@/views/planet/views/menus"], resolve),
        },
        {
          path: "/p/planet/setting",
          name: "planetSetting",
          component: (resolve) =>
            require(["@/views/planet/views/setting"], resolve),
        },
        {
          path: "/p/planet/course",
          name: "planetCourse",
          component: (resolve) =>
            require(["@/views/planet/views/course"], resolve),
        },
      ],
    },
    {
      path: "/p/planet/activityList",
      name: "activityList",
      component: (resolve) =>
        require(["@/views/planet/activityList.vue"], resolve),
    },
    {
      path: "/p/planet/user",
      name: "PlanetWiki",
      component: (resolve) => require(["@/views/planet/user.vue"], resolve),
    },
    {
      path: "/p/planet/lesson",
      name: "PlanetLesson",
      component: (resolve) => require(["@/views/planet/lesson.vue"], resolve),
    },
    {
      path: "/p/planet/live/database",
      name: "LiveDatabase",
      component: (resolve) => require(["@/views/marketing/404.vue"], resolve),
    },
    {
      path: "/p/planet/live/setting",
      name: "LiveSetting",
      component: (resolve) => require(["@/views/marketing/404.vue"], resolve),
    },
    {
      path: "/p/planet/live/list",
      name: "LiveList",
      component: (resolve) =>
        require(["@/views/planet/live/liveList.vue"], resolve),
    },
    {
      path: "/p/planet/wiki",
      name: "PlanetWiki",
      component: (resolve) => require(["@/views/marketing/404.vue"], resolve),
    },
    {
      path: "/p/accounting/home",
      name: "AccountingHome",
      component: (resolve) => require(["@/views/marketing/404.vue"], resolve),
    },
    {
      path: "/p/setting/accounting/add",
      component: () => import("@/views/setting/addAccounting2"),
      name: "PlanetAddAccounting",
      meta: { title: "添加员工", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/p/planet/future",
      name: "future",
      component: (resolve) => require(["@/views/planet/future.vue"], resolve),
    },
    {
      path: "/p/planet/vip",
      name: "vip",
      component: (resolve) => require(["@/views/planet/future.vue"], resolve),
    },
  ],

  // 订单管理
  "/order": [],

  // 售后管理
  "/aftersale": [
    {
      path: "/aftersale/detail",
      component: () => import("@/views/aftersale/detail"),
      name: "aftersaleDetail",
      meta: { title: "售后详情", prefix: "/aftersale/index" },
      hidden: true,
    },
  ],

  // 资金收益
  "/accounting": [
    {
      path: "/accounting/tax",
      component: () => import("@/views/accounting/tax"),
      name: "tax",
      meta: { title: "报税管理", prefix: "/accounting" },
      hidden: true,
    },
    {
      path: "/accounting/balance/person",
      component: () => import("@/views/accounting/personIndentify"),
      name: "personIndentify",
      meta: { title: "个人账户认证", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/balance/company",
      component: () => import("@/views/accounting/companyIndentify"),
      name: "companyIndentify",
      meta: { title: "企业及个体户认证", prefix: "/accounting/balance" },
      hidden: true,
    },
    // {
    //   path: "/accounting/balance/cash",
    //   component: () => import("@/views/accounting/extractCash"),
    //   name: "balanceCash",
    //   meta: { title: "申请转出", prefix: "/accounting/balance" },
    //   hidden: true,
    // },
    {
      path: "/accounting/extractCash",
      component: () => import("@/views/accounting/cash"),
      name: "extractCash",
      meta: { title: "申请转出", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/extractCashSuccess",
      component: () => import("@/views/accounting/extractCashSuccess"),
      name: "extractCashSuccess",
      meta: { title: "转出成功", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/hybridExtractCash",
      component: () => import("@/views/accounting/hybridExtractCash"),
      name: "hybridExtractCash",
      meta: { title: "申请转出", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/balance/indentify",
      component: () => import("@/views/accounting/indentify"),
      name: "indentify",
      meta: { title: "帐户认证", prefix: "/accounting/balance" },
      hidden: true,
    },
    {
      path: "/accounting/income/detail",
      component: () => import("@/views/accounting/detail"),
      name: "incomeDetail",
      meta: { title: "收入明细", prefix: "/accounting/income" },
      hidden: true,
    },
  ],

  // 系统设置
  "/setting": [
    {
      path: "/setting/index",
      component: () => import("@/views/setting/index"),
      name: "zizhi",
      meta: { title: "抖音资质", prefix: "/setting" },
      hidden: true,
    },
    {
      path: "/setting/self",
      component: () => import("@/views/setting/self"),
      name: "accountingSelf",
      meta: { title: "账号设置", prefix: "/setting" },
      hidden: true,
    },
    {
      path: "/setting/accounting/add",
      component: () => import("@/views/setting/addAccounting"),
      name: "addAccounting",
      meta: { title: "添加员工", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/setting/accounting/edit",
      component: () => import("@/views/setting/editAccounting"),
      name: "editAccounting",
      meta: { title: "编辑员工", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/setting/accounting/qualification",
      component: () => import("@/views/setting/qualification"),
      name: "qualification",
      meta: { title: "资质认证", prefix: "/setting/accounting" },
      hidden: true,
    },
    {
      path: "/setting/myRoleApply",
      component: () => import("@/views/setting/roleApply"),
      name: "roleApply",
      meta: { title: "角色申请" },
    },
    {
      path: "/setting/roleBaseInfoApply",
      component: () => import("@/views/setting/roleBaseInfoApply"),
      name: "roleBaseInfoApply",
      meta: { title: "角色基础申请" },
    },
    {
      path: "/setting/roleClassInfoApply",
      component: () => import("@/views/setting/roleClassInfoApply"),
      name: "roleClassInfoApply",
      meta: { title: "角色类目申请" },
    },
    {
      path: "/setting/roleAuthInfoApply",
      component: () => import("@/views/setting/roleAuthInfoApply"),
      name: "roleAuthInfoApply",
      meta: { title: "角色授权申请" },
    },
    {
      path: "/setting/ttScope",
      component: () => import("@/views/setting/ttScope"),
      name: "ttScope",
      meta: { title: "抖音账号管理" },
    },
    {
      path: "/setting/teacher/information",
      component: () => import("@/views/setting/information"),
      name: "information",
      meta: { title: "认证讲师" },
    },
    {
      path: "/setting/teacher/identificationApply",
      component: () => import("@/views/setting/identificationApply"),
      name: "identificationApply",
      meta: { title: "完善讲师认证资料" },
    },
    {
      path: "/setting/teacher/IdentificationSuccess",
      component: () => import("@/views/setting/IdentificationSuccess"),
      name: "IdentificationSuccess",
      meta: { title: "讲师认证审核" },
    },
    {
      path: "/setting/guide",
      component: () => import("@/views/setting/guide"),
      name: "guide",
      meta: { title: "入驻引导" },
    },
    {
      path: "/guide/index",
      component: () => import("@/views/setting/guide"),
      name: "guide",
      meta: { title: "入驻引导" },
    },
    // {
    //   path: "/setting/accounting/teacher",
    //   component: () => import("@/views/setting/teacher"),
    //   name: "teacherQualification",
    //   meta: { title: "讲师认证", prefix: "/setting/accounting" },
    //   hidden: true,
    // },
    // {
    //   path: "/setting/accounting/company",
    //   component: () => import("@/views/setting/company"),
    //   name: "companyQualification",
    //   meta: { title: "讲师认证", prefix: "/setting/accounting" },
    //   hidden: true,
    // },
    {
      path: "/setting/enterpriseBaseInfoApply",
      component: () => import("@/views/setting/enterpriseBaseInfoApply"),
      name: "enterpriseBaseInfoApply",
      meta: { title: "企业角色基础申请" },
    },
    {
      path: "/setting/enterpriseClassInfoApply",
      component: () => import("@/views/setting/enterpriseClassInfoApply"),
      name: "enterpriseClassInfoApply",
      meta: { title: "企业类目申请" },
    },
    {
      path: "/setting/enterpriseAuthInfoApply",
      component: () => import("@/views/setting/enterpriseAuthInfoApply"),
      name: "enterpriseAuthInfoApply",
      meta: { title: "企业角色授权申请" },
    },
  ],
};

export const appendRouterMap = appendRouter;
